import { call, put } from "redux-saga/effects";
import {
    createAddressRequest,
    createAddressSuccess,
    createAddressFailure,
    setAddresses,
} from "../../entities/addresses";
import {
    requestGetAddresses,
    requestCreateAddress,
} from "../requests/addresses";

export function* handleGetAddresses() {
    try {
        const response = yield call(requestGetAddresses);
        if (!response?.data) throw new Error("Nepostojeći odgovor sa servera");
        yield put(setAddresses(response.data));
    } catch (error) {
        console.error("Greška prilikom dohvatanja adresa:", error.message);
    }
}

export function* handleCreateAddress(action) {
    try {
        yield put(createAddressRequest());

        const response = yield call(requestCreateAddress, action.payload);
        if (!response?.data) throw new Error("Nevalidan odgovor sa servera");

        yield put(createAddressSuccess(response.data));
    } catch (error) {
        yield put(createAddressFailure(error.message || "Greška prilikom kreiranja adrese"));
    }
}
